import { ApolloClient, ApolloProvider, from } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { createRoot } from 'react-dom/client';
import { getQueryStringParams, removeQueryParamAndReplace } from 'utils';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { cache } from 'cache';
import { G } from 'enums';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
Sentry.init({
  dsn: 'https://5f557b161b414a2eabbd2d5d49f3e554@o1212399.ingest.sentry.io/6350491',
  integrations: [new BrowserTracing()],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

const { uri } = window.WHITE_LABEL_CONFIG;

const uploadLink = createUploadLink({ uri });
const params = getQueryStringParams();

if (params.t) {
  localStorage.setItem(G.token, params.t);
  removeQueryParamAndReplace('t');
}

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) => {
      return console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
    });

  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
    if (process.env.NODE_ENV !== 'development') {
      localStorage.removeItem(G.token);
      return window.location.reload();
    }
  }
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem(G.token);

  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
});

export const client = new ApolloClient({
  cache,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  link: from([errorLink, authLink.concat(uploadLink as any)]),
  connectToDevTools: true,
});

// if (process.env.NODE_ENV === 'development') {
// eslint-disable-next-line @typescript-eslint/no-var-requires
// const { worker } = require('./mocks/browser');
// worker.start();
// }

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);
root.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>
);

reportWebVitals();
